import React, {FunctionComponent} from 'react';

export interface TableProps extends React.TableHTMLAttributes<HTMLTableElement> {}

/** @component */
export const TableBase: FunctionComponent<TableProps> = props => <table {...props} />;
